import React from 'react';
import { withRouter } from 'react-router-dom';

import WhiteSpaceSvgWrapper from '../../../components/WhiteSpaceSvgWrapper';
import UhOhTurtle from '../../../components/UhOhTurtle.svg';
import TempRightActionHelper from '../components/TempRightActionHelper';
import { elements, components, fonts, copy } from '@peachjar/components';

const { ProximaNova } = fonts;
const { FullSpread, ContentColumn, WhitespaceColumn } = components;
const { Quote } = elements;
const { quotes } = copy;

const { Buttons } = components;
const { ButtonPrimaryLarge } = Buttons;

const styles = {
  header: {
    fontSize: '34px',
    fontWeight: '600',
    marginBottom: '1rem',
    fontFamily: ProximaNova,
  },
  paragraph: {
    marginBottom: '1rem',
    maxWidth: '512px',
    fontFamily: ProximaNova,
  },
};

const quote = {
  content:
    'Tell me and I forget, teach me and I may remember, involve me and I learn.',
  author: 'Benjamin Franklin',
};

export const LockedOnboarding = withRouter(({ history }) => (
  <FullSpread>
    <ContentColumn
      onClick={() => {
        history.push('/onboarding');
      }}
      rightAction={<TempRightActionHelper />}
    >
      <div className="layout-column layout-align-start-start">
        <h1 style={styles.header}>Hey!</h1>
        <p style={styles.paragraph}>
          Someone just signed for this district. No further action is needed.
          Please contact us if you have any questions.
        </p>
        <ButtonPrimaryLarge>Contact Us</ButtonPrimaryLarge>
      </div>
    </ContentColumn>
    <WhitespaceColumn>
      <WhiteSpaceSvgWrapper
        svg={<UhOhTurtle />}
        quote={quotes.jacobson_behindEveryChild}
      />
    </WhitespaceColumn>
  </FullSpread>
));



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/LockedOnboarding.jsx